// When the user scrolls down 20px from the top of the document, slide down the navbar
// window.onscroll = function() {scrollFunction()};

// function scrollFunction() {
//   if (document.body.scrollTop > 650 || document.documentElement.scrollTop > 650) {
//     document.getElementById("navigator").style.top = "0";
//   } else {
//     document.getElementById("navigator").style.top = "-50px";
//   }
// }

$(document).ready(function(){
  $('.phone-sm').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false
  });
  $('.ops ul li:first-child').click(function(){
$('.phone-sm').slick('slickGoTo', 0);
});
$('.ops ul li:nth-child(2)').click(function(){
$('.phone-sm').slick('slickGoTo', 1);
});
$('.ops ul li:nth-child(3)').click(function(){
$('.phone-sm').slick('slickGoTo', 2);
});
$('.ops ul li:nth-child(4)').click(function(){
$('.phone-sm').slick('slickGoTo', 3);
});
$('.ops ul li:nth-child(5)').click(function(){
$('.phone-sm').slick('slickGoTo', 4);
});
$('.ops ul li:nth-child(6)').click(function(){
$('.phone-sm').slick('slickGoTo', 5);
});
$('#shopify-block-552117e6-c5d1-42d9-96a4-1dc92059da88').addClass('anchor_5');
$("li#anchor_1").click(function() {
    $('html, body').animate({
        scrollTop: $(".anchor_1").offset().top
    }, 2000);
});
$("li#anchor_2").click(function() {
    $('html, body').animate({
        scrollTop: $(".anchor_2").offset().top
    }, 2000);
});
$("li#anchor_3").click(function() {
    $('html, body').animate({
        scrollTop: $(".anchor_3").offset().top
    }, 2000);
});
$("li#anchor_4").click(function() {
    $('html, body').animate({
        scrollTop: $(".anchor_4").offset().top
    }, 2000);
});
$("li#anchor_5").click(function() {
    $('html, body').animate({
        scrollTop: $(".anchor_5").offset().top
    }, 2000);
});
$('li#anchor_5').click(function(){
  $('html, body').animate({
        scrollTop: $('.jdgm-review-widget').offset().top
    }, 2000);
});
});